import { useTranslation } from 'react-i18next';
import type { CoveredBy } from '../../utils/bookingCoverage';

/**
 * Takes the place of "Fälliger Betrag" on a covered booking (ADR-0008,
 * amendment 2026-09-23). The total above keeps the real price; this names who
 * bears it. No amount is shown here on purpose: "0,00 €" beside the real total
 * would not add up (total − paid ≠ 0) and would read as "free", while the
 * full amount would read as owed by the customer. Worded like the web app's
 * summary ("Über deine Organisation abgedeckt — keine Zahlung erforderlich.").
 */
const CoveredAmountNote = ({ coveredBy }: Readonly<{ coveredBy: CoveredBy }>) => {
    const { t } = useTranslation();
    return (
        <p className={'text-sm font-semibold text-foreground mt-4'}>
            {coveredBy.organizationName
                ? t('booking_details.reservation_summary.covered_named', { organization: coveredBy.organizationName })
                : t('booking_details.reservation_summary.covered')}
        </p>
    );
};

export default CoveredAmountNote;
